export enum EBankSlipInstallmentSteps {
  initial = 'initial',
  optin = 'optin',
  installments = 'installments',
  loading = 'loading',
}
